// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"744":"1ac2e88c","801":"bcd4dd0c"}[chunkId] + ".chunk.js";
};